var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-button',_vm._g(_vm._b({staticClass:"footer-button k-br-rd-md k-pa-y-md"},'k-button',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"button-text k-text-title k-text-w-light"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }